import { postApi, getApi } from "@/util/http.js";

/** 获取发现卡片列表
 * @param {*} data
 * @param {Number} limit 每页条数
 * @param {Number} current 当前页码
 * @param {String} label 标签
 * @param {String} title 搜索标题
 * @param {Number} followed 关注 0:未关注 1:已关注
 * @param {Number} cardType 类型 -1:全部 0双面卡1便签卡2图片卡3单面卡 4文档卡 5多维卡6习题卡 7音频卡 8视频卡9文章卡
 * @param {Number} mySubmission 我的卡片投稿 （0：默认 /1：我的投稿 2他人投稿）
 * @param {Number} sortValue 排序方式 1时间 5随机
 * @param {Number} type 类型 0：卡盒，1卡片
 * @param {Number} userId 用户id（查询他人卡片）
 * @returns
 */
export const getCardList = (data) =>
  postApi(`/admin/community/discovery/findPageList`, {
    ...data,
    followed: 0,
    cardType: -1,
    type: 1,
  });

/** 获取用户喜欢的卡片列表
 *  @param {Number} limit 每页条数
 *  @param {Number} current 当前页码
 */
export const getLikeList = (data) =>
  getApi(`/admin/community/discovery/cardThumb/findPageList`, data);

/** 获取发现卡片详情
 *  @param {Number} id 卡片id
 */
export const findById = (data) =>
  getApi(`/admin/community/discovery/findById`, data);

/** 发现卡片删除
 *  @param {Number} id 卡片id
 */
export const deleteCard = (data) =>
  getApi(`/admin/community/discovery/deleteById`, data);

/** 发现卡片点赞
 *  @param {Number} discoveryCardId 卡片id
 */
export const cardUp = (data) =>
  postApi(`/admin/community/discovery/cardThumb/insertOrUpdate`, data);

/** 添加采集记录
 *  @param {Number} id 卡片id
 * @returns
 */
export const addCollection = (data) =>
  postApi(`/admin/community/discovery/updateCollectNum`, data);

/** 获取默认卡盒id
 *
 */
export const getDefaultCassetteId = () =>
  postApi(`/admin/shanniancard/getShannianCassette`);

/**文件资源链接转id
 *  @param {String} resourceUrl 文件资源链接
 *  @param {String} picUrl 封面图（非必填）
 *  @param {String} resourceName 资源名称
 *  @param {String} suffixName 资源类型后缀
 *  @param {Number} totalTime 时间
 *  @param {Number} type 0:视频 1:音频
 *  @param {Number} uploadLocation 0
 *  @param {Number} videoRatio 视频比例
 */
export const resourceUrlToId = (data) =>
  postApi(`/admin/resource/insertOrUpdate`, data);

/** 采集卡片至默认卡盒
 *  @param {Number} cardType 卡片类型
 *  @param {Number} cassetteId 默认卡盒id
 *  @param {Number} labelList   标签列表
 */
export const collectCard = (data) =>
  postApi(`/admin/shanniancard/insertOrUpdate`, data);

/** 查询评论列表
 *  @param {Number} discoveryCardId 卡片id
 *  @param {Number} limit 每页条数
 *  @param {Number} current 当前页码
 */
export const getCommentList = (data) =>
  getApi(`/admin/community/discovery/cardComment/findPageList`, data);

/** 新增评论
 *  @param {Number} ccid 卡盒id
 *  @param {Number} discoveryCardId 卡片id
 *  @param {String} content 评论内容
 */
export const addComment = (data) =>
  postApi(`/admin/community/discovery/cardComment/insertOrUpdate`, data);

/** 回复评论
 *  @param {Number} ccid 卡盒id
 *  @param {Number} discoveryCardId 卡片id
 *  @param {Number} commentId 回复的评论id
 *  @param {String} toUserid  回复的用户id
 *  @param {String} content 评论内容
 */
export const replyComment = (data) =>
  postApi(`/admin/community/discovery/cardRemark/insertOrUpdate`, data);

/** 评论or回复点赞
 *  @param {Number} ccid 卡盒id
 *  @param {Number} discoveryCardId 卡片id
 *  @param {Number} commentId 评论id
 *  @param {Number} remarkId 回复id
 *  @param {Number} type 是否点赞 1:点赞 0:取消点赞
 */
export const commentUp = (data) =>
  postApi(
    `/admin/community/discovery/cardCommentRemarkThumb/insertOrUpdate
`,
    data
  );

/** 删除评论
 *  @param {Number} id 评论id
 */
export const deleteComment = (data) =>
  getApi(`/admin/community/discovery/cardComment/deleteById`, data);

/** 删除回复
 *  @param {Number} id 回复id
 */
export const deleteReply = (data) =>
  getApi(`/admin/community/discovery/cardRemark/deleteById`, data);

/** 点播视频获取视频地址
 * @param {Number} resourceId 资源id
 * @param {Number} uploadLocation  0：中台， 1：社区
 */
export const getVideoUrl = (data) => getApi(`/admin/resource/getPlayUrl`, data);

/** 分享到小班级
 *  @param {Number} discoveryCardId 卡片id
 *  @param {Number} classId 小班级id
 *  @param {String} type 类型 5
 *  @param {String} content 内容
 */
export const shareToClass = (data) =>
  postApi(`/admin/classTrends/addClassTrend`, data);
